/**
 * Preferencje doboru konta (`GET /kit-preferences`, `/preferencje`) w wyborze modelu Projektu 3D (prośba właściciela
 * 2026-10-12): moduły, falowniki i magazyny z preferencji idą pierwsze. Z preferencji bierzemy:
 * - wybrane konkretne modele (`wybrane.<kat>.modele`: id, nazwa, producent, img) jako gotowe pozycje do kliknięcia;
 * - producentów: z listy marek konta, z wybranych serii i z wybranych modeli, w tej kolejności, bez powtórzeń;
 * - serie (`wybrane.<kat>.serie`) do ustawienia ich na początku listy serii.
 */

const KATEGORIE = {
  moduly: { klucz: 'panels', marki: 'module_manufacturers' },
  falownik: { klucz: 'inverter', marki: 'inverter_manufacturers' },
  magazyn: { klucz: 'battery', marki: 'battery_manufacturers' },
}

const unikalne = (lista) => [...new Set(lista.filter(Boolean))]

export const preferencjeKategorii = (prefs, kategoria) => {
  const k = KATEGORIE[kategoria]
  if (!prefs || !k) return { modele: [], producenci: [], serie: [] }
  const wybrane = prefs.wybrane?.[k.klucz] || {}
  const modele = (wybrane.modele || []).filter((m) => m && m.id)
  const serie = (wybrane.serie || []).filter((s) => s && s.producent && s.seria)
  return {
    modele,
    producenci: unikalne([...(prefs[k.marki] || []), ...serie.map((s) => s.producent), ...modele.map((m) => m.producent)]),
    serie,
  }
}

/**
 * Producenci katalogu z preferowanymi na początku: [{ value, label, grupa }]. Preferowany producent, którego nie ma
 * w katalogu tej kategorii, odpada (nie da się z niego wybrać modelu).
 */
export const producenciZPreferencjami = (lista, preferowani) => {
  const wKatalogu = new Set(lista)
  const pierwsi = preferowani.filter((p) => wKatalogu.has(p))
  if (!pierwsi.length) return lista.map((p) => ({ value: p, label: p }))
  const reszta = lista.filter((p) => !pierwsi.includes(p))
  return [
    ...pierwsi.map((p) => ({ value: p, label: p, grupa: 'Z Twoich preferencji' })),
    ...reszta.map((p) => ({ value: p, label: p, grupa: 'Wszyscy producenci' })),
  ]
}

/** Serie producenta (`opcjeSerii`: [{ value, count }]) z preferowanymi na początku. */
export const serieZPreferencjami = (serie, preferowane, producent) => {
  const moje = new Set(preferowane.filter((s) => s.producent === producent).map((s) => s.seria))
  const opcja = (s) => ({ value: s.value, label: `${s.value} (${s.count})` })
  if (!serie.some((s) => moje.has(s.value))) return serie.map(opcja)
  return [
    ...serie.filter((s) => moje.has(s.value)).map((s) => ({ ...opcja(s), grupa: 'Z Twoich preferencji' })),
    ...serie.filter((s) => !moje.has(s.value)).map((s) => ({ ...opcja(s), grupa: 'Pozostałe serie' })),
  ]
}
